import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const userManagement = createApi({
    reducerPath: "userManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        getStudentOrEmployeeId: builder.mutation({
            query: ({id}) => ({
                url: `v1/${locale}/users/get-student-or-employee-id/${id}`,
                method: "GET",
            }),
        }),

        addUserProfileDataView: builder.mutation({
            query: ({userId, body}) => ({
                url: `v1/${locale}/user/${userId}/profile/data-view`,
                method: "POST",
                body: body,
            }),
        }),

        getUserProfileDataView: builder.mutation({
            query: ({userId}) => ({
                url: `v1/${locale}/user/${userId}/profile/data-view`,
                method: "GET",
            }),
        }),

        updatUserProfileDataView: builder.mutation({
            query: ({userId, body}) => ({
                url: `v1/${locale}/user/${userId}/profile/data-view`,
                method: "PATCH",
                body: body,
            }),
        }),
    }),
});

export const {
    useGetStudentOrEmployeeIdMutation,
    useAddUserProfileDataViewMutation,
    useGetUserProfileDataViewMutation,
    useUpdatUserProfileDataViewMutation
} = userManagement;
